/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { ToolTip } from '@insticator/insticator-ui';
import LinkControl from './linkcontrol/linkcontrol';
// styles
import injectSheet from 'react-jss';
import styles from './linkcontrols_styles';



/* ========== ~~~~~~~~~~ LINK CONTROLS ~~~~~~~~~~ ========== */
const LinkControls = injectSheet(styles)((props) => {

    const renderLinkControl = option => (
        <LinkControl key={option.value} value={option.value} text={option.text}
            selected={props.selected === option.value} handleSelect={props.handleSelect} 
            disabled={option.disabled}/>
    );

    return(
        <div className={`linkcontrols ${props.classes.linkcontrols}`}>
            {props.options.map(option => 
                option.disabled ? 
                    <ToolTip trigger={`mouseenter focus`} content={'Calendar date range duration is too long to support this roll-up period.'}>
                        { renderLinkControl(option) }
                    </ToolTip> 
                    : 
                    renderLinkControl(option)
            )}
        </div>
    )
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default LinkControls;
